/**
 * Re-export shared API utils and questionnaire-specific base URL.
 */
import {
  getApiUrl,
  getApiHeaders,
  getApiAuthHeaders,
  throwIfAuthErrorResponse,
  apiFetch,
} from '../../../shared/utils/api';

export {
  getApiUrl,
  getApiHeaders,
  getApiAuthHeaders,
  throwIfAuthErrorResponse,
  apiFetch,
};

/** Base URL for questionnaire API (backend prefix /api/questionnaire). */
export const getQuestionnaireApiBase = (): string => `${getApiUrl()}/api/questionnaire`;
